'use strict';
/**
 * Configuration and util class of the base, i.e. the maximal arity of the first
 * level of the tree.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var Base =
/*#__PURE__*/
function () {
  /**
   * @param {Number} [b = 3] The number of bits at level 0 of the dense space.
   */
  function Base() {
    var b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;

    _classCallCheck(this, Base);

    this._b = b;
  }

  _createClass(Base, [{
    key: "getBitBase",

    /**
     * Process the number of bits usage at a certain level of dense space.
     * @param {Number} level The level in dense space, i.e., the number of
     * concatenations of the identifier.
     * @return {Number} The number of bit to encode a single path concatenation
     * at the depth in argument.
     */
    value: function getBitBase(level) {
      return this._b + level;
    }
  }, {
    key: "getSumBit",

    /**
     * Process the total number of bits usage to get to a certain level.
     * @param {Number} level The level in dense space, i.e., the number of
     * concatenations of the identifier.
     * @return {Number} The number of bits required to encode the path
     * comprising level concatenations.
     */
    value: function getSumBit(level) {
      var n = this.getBitBase(level);
      var m = this._b - 1;
      return n * (n + 1) / 2 - m * (m + 1) / 2;
    }
  }, {
    key: "getInterval",

    /**
     * Process the number of possible paths between two LSEQNode.
     * @param {Number} level The depth of the tree to process.
     * @param {LSeqNode} p The previous LSeqNode.
     * @param {LSeqNode} q The next LSeqNode.
     * @return {Number} The interval between the two nodes at the depth in
     * argument.
     */
    value: function getInterval(level, p, q) {
      var sum = 0,
          i = 0,
          pIsGreater = false,
          commonRoot = true,
          prevValue = 0,
          nextValue = 0;

      while (i <= level) {
        prevValue = p && p.t.p || 0;
        nextValue = q && q.t.p || 0; // #1 check if paths are identical

        if (commonRoot && prevValue !== nextValue) {
          commonRoot = false;
          pIsGreater = prevValue > nextValue;
        } // #2 process the value to add to interval


        if (pIsGreater) {
          nextValue = Math.pow(2, this.getBitBase(i)) - 1;
        }

        if (commonRoot || pIsGreater || i !== level) {
          sum += nextValue - prevValue;
        } else {
          sum += nextValue - prevValue - 1;
        }

        if (i !== level) {
          sum *= Math.pow(2, this.getBitBase(i + 1));
        }

        ; // #3 iterate over path concatenations

        p = p && p.child || null;
        q = q && q.child || null;
        ++i;
      }

      return sum;
    }
  }]);

  return Base;
}();

;
module.exports = Base;